<template>
    <!-- 医共体集团 -->
    <productSchema :config="config"></productSchema>
</template>

<script>
import { config } from './js/medical_community_management'
import productSchema from '../common/product_schema.vue'
export default {
    name: '',
    components: { productSchema },
    data() {
        return {
            config: config,
        };
    },
    computed: {
    },
    watch: {
    },
    methods: {

    },
};
</script>

<style scoped lang="less"></style>
